var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { enumNumericValues } from '@sonar-software/sonar-ts-lib';
import { FieldUsageTag } from './FieldUsageTag';
import { SonarSelector } from '../SonarSelector';
import { FieldUsageId, patchSalesforceSonarObject } from '@sonar-software/sonar-core';
import { genericProcessingFailure, useOptimisticUpdate, usePrevious, useProcessing, useSonarObjectReference, useUpdateSonarObjectReference } from '@hooks';
import React, { useCallback, useEffect, useState } from 'react';
function updateFieldUsage(sonarObjectId, fieldUsageId) {
    return __awaiter(this, void 0, void 0, function* () {
        var _a;
        const result = yield patchSalesforceSonarObject({
            fieldUsageId,
            sonarObjectId
        });
        return (_a = result.data) !== null && _a !== void 0 ? _a : genericProcessingFailure;
    });
}
const usageOptions = enumNumericValues(FieldUsageId)
    .map((value) => ({
    label: React.createElement(FieldUsageTag, { fieldUsageId: value }),
    value: value
}));
export const FieldUsageSelector = ({ getPopupContainer, isSpreadsheet, sonarObjectId }) => {
    const { salesforce } = useSonarObjectReference(sonarObjectId);
    const { fieldUsageId } = salesforce;
    const [value, setValue] = useState(fieldUsageId);
    const { update } = useUpdateSonarObjectReference();
    const { start, state, stop } = useProcessing();
    const { changes } = useOptimisticUpdate(sonarObjectId);
    const previousFieldUsage = usePrevious(fieldUsageId);
    useEffect(() => {
        if (fieldUsageId !== previousFieldUsage) {
            setValue(fieldUsageId);
        }
    }, [fieldUsageId, previousFieldUsage, value]);
    const handleOnChange = useCallback((change) => __awaiter(void 0, void 0, void 0, function* () {
        const newValue = change !== null && change !== void 0 ? change : FieldUsageId.None;
        if (fieldUsageId === newValue) {
            return;
        }
        const fallbackValue = value;
        setValue(newValue);
        start();
        const updateResult = yield updateFieldUsage(sonarObjectId, newValue);
        if (updateResult === null || updateResult === void 0 ? void 0 : updateResult.success) {
            update({
                salesforce: { fieldUsageId: newValue },
                sonarObjectId
            });
        }
        else {
            setValue(fallbackValue);
        }
        stop(updateResult);
    }), [fieldUsageId, sonarObjectId, start, stop, update, value]);
    return (React.createElement(SonarSelector, { allowClear: fieldUsageId !== FieldUsageId.None, boxless: !isSpreadsheet, className: 'salesforce-field-usage-selector', defaultValue: fieldUsageId, getPopupContainer: getPopupContainer, isSalesforce: true, isSpreadsheet: isSpreadsheet, labelRender: (option) => React.createElement(FieldUsageTag, { fieldUsageId: option.value }), onChange: handleOnChange, options: usageOptions, placeholder: React.createElement(FieldUsageTag, { fieldUsageId: FieldUsageId.None }), readOnlyDisplay: React.createElement(FieldUsageTag, { fieldUsageId: fieldUsageId }), showArrow: true, showSearch: false, state: changes.fieldUsageId ? { isProcessing: true } : state, value: value }));
};
